import { useSelector } from "react-redux";
import SidebarItem from "./SidebarItem";

const SidebarMenu = ({ menu }) => {
  const userRole = useSelector((state) => state.auth.user?.rol);

  const filteredMenu = menu
    .map((group) => ({
      ...group,
      items: group.items
        .filter((item) => !item.roles || item.roles.includes(userRole))
        .map((item) => {
          // Si el item tiene submenu, filtrar también los submenús por rol
          if (item.submenu) {
            return {
              ...item,
              submenu: item.submenu.filter(
                (subitem) => !subitem.roles || subitem.roles.includes(userRole),
              ),
            };
          }
          return item;
        })
        .filter((item) => !item.submenu || item.submenu.length > 0), // Remover dropdowns vacíos
    }))
    .filter((group) => group.items.length > 0);

  return (
    <div className="sidebar-menu-area">
      <ul className="sidebar-menu">
        {filteredMenu.map((group, index) => (
          <div key={index}>
            <li className="sidebar-menu-group-title">{group.title}</li>
            {group.items.map((item, idx) => (
              <SidebarItem key={idx} item={item} />
            ))}
          </div>
        ))}
      </ul>
    </div>
  );
};

export default SidebarMenu;
